import React from 'react';
import { AlertCircle } from 'lucide-react';
import Modal from './Modal';

interface ErrorNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string;
}

const ErrorNotificationModal: React.FC<ErrorNotificationModalProps> = ({
  isOpen,
  onClose,
  errorMessage,
}) => {
  if (!isOpen) return null;

  return (
    <Modal onClose={onClose} maxWidth='max-w-md' isBackgroundTransparent={true}>
      <div className="px-4 py-4 flex flex-col justify-start">
        <div className="flex items-center mb-2">
          <AlertCircle className="w-6 h-6 text-red-500 mr-2" />
          <h2 className="text-xl font-semibold text-red-600">เกิดข้อผิดพลาด</h2>
        </div>
        <p className="text-lg mb-4 text-gray-700">{errorMessage}</p>
        <div className="text-right">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
          >
            ปิด
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorNotificationModal;
